<template>
  <div
    class="notice-panel"
    v-loading="tableLoading"
    element-loading-text="拼命加载中"
  >
    <div class="header">您有{{ unReadNotice }}条未读消息</div>
    <div class="notice-content">
      <div
        v-for="item in pageResult.content"
        :key="item.id"
        class="notice-item"
        @click="viewItem(item)"
      >
        <span class="notice-icon">
          <i
            v-if="item.isReaded"
            class="fa fa-envelope-open fa-lg"
            style="color:#909399;font-size:16px;"
          ></i>
          <i
            v-else
            class="fa fa-envelope fa-lg"
            style="color:#E6A23C;font-size:16px;"
          ></i>
        </span>
        <span class="notice-content">{{ item.title }} </span>
      </div>
      <div class="notice-footer" @click="viewAllNotice">查看所有消息</div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      append-to-body
      v-loading="dialogLoading"
      element-loading-text="拼命加载中"
    >
      <div slot="title">
        {{ curNotice.title }}
      </div>
      <div v-html="curNotice.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NoticePanel",
  data() {
    return {
      tableLoading: false,
      dialogLoading: false,
      dialogVisible: false,
      // 分页信息
      pageRequest: {
        pageNum: 1,
        pageSize: 10,
        params: {
          isReaded: false
        }
      },
      pageResult: {},
      curNotice: {}
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [
        {
          key: "1",
          icon: "fa fa-envelope-o",
          content: "你修改了用户密码"
        },
        {
          key: "2",
          icon: "fa fa-music",
          content: "你修改了用户头像"
        },
        {
          key: "3",
          icon: "fa fa-edit",
          content: "今日25名新成员加入"
        },
        {
          key: "4",
          icon: "fa fa-edit",
          content: "您发表了一篇新随笔"
        }
      ]
    }
  },
  methods: {
    findPage: function(data) {
      this.tableLoading = true;
      //获取数据
      this.$api.user
        .getNotices(this.pageRequest)
        .then(res => {
          this.tableLoading = false;
          //操作成功
          if (res.code == 200) {
            this.pageResult = res.data;
            //设置全局变量
            this.$store.commit("setUnReadNotice", res.data.totalSize);
          } else {
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    },
    //查看通知，更改状态为已读
    viewItem: function(data) {
      this.dialogVisible = true;
      this.curNotice = data;

      this.dialogLoading = true;
      //标识为已读
      data.isReaded = true;
      //获取数据
      this.$api.user
        .getOneNotice(data.id)
        .then(res => {
          this.dialogLoading = false;
          //操作成功
          if (res.code == 200) {
            this.curNotice = res.data;
            //设置全局变量
            this.$store.commit("setUnReadNotice", this.unReadNotice - 1);
          } else {
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    },
    viewAllNotice: function() {
      this.$router.push("/user/notice");
    }
  },
  computed: {
    ...mapState({
      unReadNotice: state => state.user.unReadNotice
    })
  },
  mounted() {
    this.findPage();
  }
};
</script>

<style lang="scss" scoped>
.notice-panel {
  font-size: 15px;
  width: 250px;
  margin: -12px;
}
.header {
  padding-left: 10px;
  font-size: 14px;
  text-align: center;
  padding-top: 6px;
  padding-bottom: 6px;
}
.notice-content {
  font-size: 12px;
}
.notice-item {
  border-color: rgba(180, 190, 190, 0.8);
  border-top-width: 1px;
  border-top-style: solid;
  padding-top: 10px;
  padding-bottom: 10px;
}
.notice-item:hover {
  cursor: pointer;
  background: #b1a6a61e;
}
.notice-icon {
  padding-left: 10px;
  padding-right: 5px;
}
.notice-footer {
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: rgba(180, 190, 190, 0.8);
  border-top-width: 1px;
  border-top-style: solid;
}
.notice-footer:hover {
  cursor: pointer;
  background: #b1a6a61e;
}
</style>



// WEBPACK FOOTER //
// src/views/Core/NoticePanel.vue